import React from 'react';
import { Typography, Box, Avatar } from '@mui/material';
import { Circle as CircleIcon, Work as WorkIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { formatDistanceToNow } from 'date-fns';

/** Someone applied for a position you announced (consortium or organization openings). */
export default function PositionNotificationCard({ notification, onMarkRead }) {
  const navigate = useNavigate();
  const p = notification.payload || {};
  const open = () => {
    if (!notification.is_read && onMarkRead) onMarkRead();
    if (p.position_id) navigate(`/positions/${p.position_id}/?applicants=1`);
  };
  return (
    <Box onClick={open} sx={{
      display: 'flex', alignItems: 'flex-start', gap: 1.5, py: 1.25, px: 2, borderBottom: '1px solid', borderColor: 'divider',
      backgroundColor: notification.is_read ? 'transparent' : 'action.hover', cursor: 'pointer', '&:hover': { backgroundColor: 'action.selected' },
    }}>
      <Avatar src={p.from_user_avatar_url || undefined} sx={{ width: 34, height: 34, mt: 0.25, bgcolor: '#0369a1' }}><WorkIcon sx={{ fontSize: 18 }} /></Avatar>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography variant="body2">
          <Box component="span" fontWeight={600}>{p.from_user_name || 'Someone'}</Box>
          <Box component="span" color="text.secondary"> applied for </Box>
          <Box component="span" fontWeight={600}>{p.position_title || 'your position'}</Box>
        </Typography>
        {p.host_name && <Typography variant="caption" color="text.secondary" display="block" noWrap>{p.host_name}</Typography>}
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexShrink: 0 }}>
        <Typography variant="caption" color="text.secondary" sx={{ whiteSpace: 'nowrap' }}>
          {formatDistanceToNow(new Date(notification.created), { addSuffix: true })}
        </Typography>
        {!notification.is_read && <CircleIcon sx={{ fontSize: 8, color: 'primary.main' }} />}
      </Box>
    </Box>
  );
}
